import React from 'react';
import { Field } from 'formik';
import { startCase } from 'lodash';
import * as yup from 'yup';

import { Box, Flex, Text } from 'shared/components/display';
import { StepFieldProps } from 'shared/components/forms/MultiStepForm/interfaces';
import TextInput from 'shared/components/TextInput';

import { CREATOR_COPY } from 'shared/config/copy';
import { CONSTRAINTS, MESSAGES } from 'shared/config/validations';
import { TEXT_VARIANTS } from 'shared/styles/text';

import styles from './styles';
export const NameFormFields: React.FC<StepFieldProps> = () => {
  return (
    <Box css={styles}>
      <Text variant={TEXT_VARIANTS.SUBHEADING} className="name-form__subheading">
        {CREATOR_COPY.CAPTION_NAME_DISPLAY}
      </Text>
      <Flex className="name-form__input-container">
        <Field
          name={NAME_FIELDNAMES.FIRST}
          component={TextInput}
          placeholder={`${startCase(NAME_FIELDNAMES.FIRST)}*`}
          label={`${startCase(NAME_FIELDNAMES.FIRST)}*`}
          className="name-form__input"
        />
        <Field
          name={NAME_FIELDNAMES.LAST}
          component={TextInput}
          placeholder={`${startCase(NAME_FIELDNAMES.LAST)}*`}
          label={`${startCase(NAME_FIELDNAMES.LAST)}*`}
          className="name-form__input"
        />
      </Flex>
    </Box>
  );
};

export const NAME_FIELDNAMES = {
  FIRST: 'firstName',
  LAST: 'lastName',
};

export const nameSchema = yup.object({
  [NAME_FIELDNAMES.FIRST]: yup
    .string()
    .matches(CONSTRAINTS.NO_SPECIAL_CHARACTERS_CONSTRAINT, {
      message: MESSAGES.NO_SPECIAL_CHARACTERS,
    })
    .customRequiredString(),
  [NAME_FIELDNAMES.LAST]: yup
    .string()
    .matches(CONSTRAINTS.NO_SPECIAL_CHARACTERS_CONSTRAINT, {
      message: MESSAGES.NO_SPECIAL_CHARACTERS,
    })
    .customRequiredString(),
});
